<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QtftwR/tc-custom/9781467464024.jpg?1730409574387" alt="This image is the cover for the book The Books of Ezra and Nehemiah, New International Commentary on the Old Testament (NICOT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Books of Ezra and Nehemiah, New International Commentary on the Old Testament (NICOT)
      </h1>
      <p class="bookDescription body article font2">
        <p>The books of Ezra and Nehemiah represent a significant turning point in biblical history. They tell the story not only of the rebuilding of the temple in Jerusalem but also of the resurrection of God’s people from the death of exile. Hannah Harrington thus begins her commentary with an evocative description of these books as “the story of a new Israel forged out of the old” and “the text of a people clinging to their genealogical past and attempting to preserve their heritage while walking forward into uncharted territory.” </p><p>Throughout this commentary, Harrington combines analytical research on the language and culture behind the books of Ezra and Nehemiah with challenging thoughts for the Christian church today, bringing to bear a unique perspective on these books not as the end of Old Testament history but as early documents of the Second Temple period. Accordingly, Harrington incorporates a wealth of information from other Jewish literature of the time to freshly illuminate many of the topics and issues at hand while focusing on the interpretation and use of these books for Christian life today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah K. Harrington
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Hannah K. Harrington</B>&#160;is professor of Old Testament at Patten University, Oakland, California. Along with her numerous articles on the Bible, Second Temple Judaism, and Christianity, Harrington&#39;s other books include&#160;<I>Holiness: Rabbinic Judaism and the Graeco-Roman World</I>&#160;and&#160;<I>The Purity and Sanctuary of the Body in Second Temple Judaism.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d700758